export const recaptchaConfig = {
  key: '6LeN2F8eAAAAABV6a1p6UGIoQdDZ5D7y0XKXsAdG',
}
